"use client";

import React, { useState } from "react";

import { ButtonNova } from "@/components/ui-kit/ButtonNova/ButtonNova";
import { InputText } from "@/components/ui-kit/InputText/InputText";
import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useLearning } from "@/context/NutrafolAcademyContext";
import { cn, isEmailValid } from "@/utils/general";
import { segmentEvent } from "@/utils/segmentfunctions";

import LearningProgress from "./LearningProgress";

const BADGE_IMAGE =
  "https://images.ctfassets.net/0rbfqd9c4jdo/3gYqOdUpTnXCHb66ypx5Hf/ab69e7ab2bc5dc0c806baab958c757e6/learning-complete-badge-new.png";

const EnterEmail = () => {
  const { handleEmailSubmit } = useLearning();
  const [emailError, setEmailError] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    if (emailError) setEmailError(false);
  };

  const submitEmail = () => {
    if (inputValue === "") {
      return setEmailError(true);
    }

    if (!isEmailValid(inputValue)) {
      return setEmailError(true);
    }

    segmentEvent("Nutrafol Academy Completed", {
      academy_program_name: "Nutrafol Academy Accreditation",
      accreditation_status: "completed",
      completion_timestamp: new Date().toISOString(),
      email: inputValue,
      first_name: "",
      last_name: "",
    });
    handleEmailSubmit();
  };

  return (
    <div className="flex flex-col lg:flex-row h-full items-center justify-center md:justify-between gap-6 xl:gap-10">
      <div className="flex flex-col items-center md:mt-10 lg:mt-0 lg:w-[368px]">
        <div className="mb-6 lg:mb-10 w-[200px] lg:w-[250px]">
          <Picture
            src={BADGE_IMAGE}
            alt="Nutrafol Academy Hair Certified"
            className="block w-full"
          />
        </div>
        <div>
          <LearningProgress isSidebar={false} />
        </div>
      </div>
      <div className="lg:flex-1 max-w-[336px] lg:max-w-none">
        <TextElementNova
          text="Enter your email to submit your accreditation confirmation."
          className="Title-20-Super-Normal text-nova-base-white text-center mb-10"
        />
        <div className="form-group lg:max-w-[400px] lg:mx-auto">
          <InputText
            name="email"
            id="email"
            type="text"
            visualName="Email Address"
            value={inputValue}
            onChange={handleInputChange}
            errors={emailError ? "Please enter a valid email address." : undefined}
            touched={!!emailError}
            className={cn(
              "!mb-2 [&_label_span]:!text-nova-base-white [&_label]:!bg-nova-base-black",
              "[&_input]:!bg-transparent [&_input]:!border-nova-transparency-white-40 [&_input]:!text-nova-base-white",
              "[&_input:focus]:!border-nova-base-white",
              emailError &&
                "[&_label_span]:!text-nova-functional-error [&_input]:!border-nova-functional-error [&_input]:!text-nova-functional-error"
            )}
          />
          <ButtonNova
            label="Submit"
            level="Primary"
            width="100%"
            icon="Right"
            onClick={submitEmail}
          />
        </div>
      </div>
    </div>
  );
};

export default EnterEmail;
